import { restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import PermissionService from '@/utils/permission-service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ApolloClient = any;

export default async function(apolloClient: ApolloClient): Promise<void> {
  PermissionService.reset();
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset', 'color: orange;', e.message);
  }
}
